import React, { useState, useEffect } from "react";
import { MDBContainer } from "mdbreact";
import Helmet from "react-helmet";

import "./styles.css";

import Banner from "../../../template/Banner";
import BlogCard from "../../../template/BlogCard";
import Loader from "../../../template/Loader";
import Pagination from "../../../template/Pagination";

import bannerImg from "../../../../assets/img/eventos/banner.jpg";

import api from "../../../../services/api";

export default () => {
  const [eventsData, setEventsData] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  const description =
    "Lorem ipsum dolor sit, amet consectetur adipisicing elit.";

  useEffect(() => {
    (async function fetchNewsData() {
      setLoading(true);

      try {
        const { data } = await api.get(
          `/posts?pagesize=3&page=${page}&category=3`
        );

        if (data.success) {
          setEventsData(data.posts);
          setData(data);
        }
      } catch (error) {
        console.error(error.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [page]);

  return (
    <div className="events">
      <Helmet>
        <title>Eventos - Ceprevi Itapetininga</title>
      </Helmet>

      <Banner title="EVENTOS" subtitle={description} img={bannerImg} />

      <MDBContainer className="content d-flex align-items-center justify-content-center flex-column">
        <h1>Lorem Ipsum</h1>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum
          obcaecati quas dignissimos esse temporibus recusandae earum
          reprehenderit excepturi, maiores at numquam, non sed laboriosam
          deleniti aut rem veritatis tempore necessitatibus! Lorem, ipsum dolor
          sit amet consectetur adipisicing elit. Earum assumenda explicabo
          veniam praesentium nulla optio similique suscipit repudiandae a.
          Accusamus beatae possimus, quos rerum amet tempore sunt corporis culpa
          animi.
        </p>
      </MDBContainer>

      <MDBContainer className="d-flex cards align-items-center">
        {loading ? (
          <Loader />
        ) : (
          eventsData &&
          eventsData.map((event) => (
            <BlogCard
              key={event.id}
              img={event.image_url}
              date={event.date}
              title={event.title}
              subtitle={event.description}
              path={`/nossa-atuacao/eventos/${event.slug}`}
            />
          ))
        )}
      </MDBContainer>
      <Pagination setPage={setPage} page={page} totalPage={data.total_page} />
    </div>
  );
};
